import { CompassCardUI } from '@scale/compass-ui/types';
import { ConfigSchema, Metric } from '@scale/shared/types/quality/diversity';
import {
  PromptDiversityCardShared,
  type PromptDiversitySchemaType,
  type PromptDiversityContext,
  PROMPT_DIVERSITY,
} from '@scale/genai-compass-shared/cards/prompt_diversity';
import { faShuffle } from '@fortawesome/pro-solid-svg-icons';
import PromptDiversityCardComponent from './PromptDiversityCardComponent';

const defaultContext: PromptDiversityContext = {
  cardType: PROMPT_DIVERSITY,
  projectId: '',
  taskIdColumn: '',
  promptColumn: '',
  projectType: 'general',
  // note that this is just to appease the type checker
  // the default values for ngrams metrics are set in
  // @scale/shared/src/types/quality/diversity.ts
  // in the zod schema
  diversityConfig: ConfigSchema.parse({
    metric: Metric.Type,
    metricConfig: {},
  }),
};

export const PromptDiversityCardInfo: CompassCardUI<PromptDiversitySchemaType> = {
  ...PromptDiversityCardShared,
  title: 'Prompt Diversity',
  inBeta: true,
  icon: 'calculator',
  toolTip: 'Analyze the diversity of prompts for tasks',
  defaultContext,
  button: {
    icon: faShuffle,
  },
  component: PromptDiversityCardComponent,
};
